export const GeneralStyles = {
    textCenter: {
        textAlign: 'center'
    },
    btnGrey: {
        backgroundColor: "#9e9e9e",
        color: "rgb(255, 255, 255)",
        '&:hover': {
            backgroundColor: "#424242"
        }
    }
}
